export default "__VITE_ASSET__CIRk9Xtn__"